import { render, staticRenderFns } from "./NpaAnswers.vue?vue&type=template&id=85e3c1ae&scoped=true"
import script from "./NpaAnswers.vue?vue&type=script&lang=js"
export * from "./NpaAnswers.vue?vue&type=script&lang=js"
import style0 from "./NpaAnswers.vue?vue&type=style&index=0&id=85e3c1ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e3c1ae",
  null
  
)

export default component.exports